export default __webpack_public_path__ + "static/media/TerraViz Logo White.d20607d6.png";